import { Fragment, useState } from 'react';
import './DetailsApprove.scss';
import { Col, Form, Row } from 'react-bootstrap';
import SubmitBtn from '../../../Form/submit-button/submit-button.component';

declare function Translate(key: string): string;

const DetailsApprove = props => {
  const [approveCb, setApproveCb] = useState(false);  
    
  var link3 = Translate('*link3*'); 
 
  const approveChecked = () => {
    setApproveCb(!approveCb);    
  };

  const aprroveCheckedPress = (event) => {
    event.preventDefault();
    if (event.charCode === 13){
      approveChecked();
    }
  }

  const endProccess = () => {      
    props.ContactStepCompleted();    
  }

  const onSignupTermsClick = () => {   
    window.open(link3, "_blank");     
  };

  const onSignupTermsPress = (event) => {
    event.preventDefault();  
    if (event.charCode === 13 || event.charCode === 32){  
      onSignupTermsClick();  
    }  
  };

  return (
    <Fragment>           
      <Form className='normal-form'>               
        <Row className='mt-4'>
          <Form.Group controlId='checkApprove' as={Col} xs={12}>
            <Form.Check type='checkbox' className='d-flex align-items-center approve-check-container'>
              <Form.Check.Input
                type='checkbox'
                checked={approveCb}
                onChange={approveChecked}
                onKeyPress={aprroveCheckedPress}
                className='approve-check'
                aria-required="true"
              />
              <Form.Check.Label  className='signupTermsLabel' >
                {Translate('N_General_SignUp_Terms_of_use_1')}
                <span>
                  &nbsp;
                  <a  
                    id='signupTerms' 
                    className='signupTerms'              
                    onClick={onSignupTermsClick}
                    onKeyPress={onSignupTermsPress} 
                    tabIndex={0}   
                  >
                  {Translate('N_General_SignUp_Terms_of_use_2')}
                  </a>
                  &nbsp;
                </span>
              </Form.Check.Label>
            </Form.Check>
          </Form.Group>
        </Row>
        <Row className='mb-5'>
          <Col xs={5}>             
            <SubmitBtn
              title={Translate('N_Login_Bio_ID_end_button')}
              id="contactSubmit"
              action={endProccess}
              showIcon={false}
              disabled={!approveCb}
            />
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default DetailsApprove;